// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"0f22bc90","31":"be1fdc18","160":"9906e9dd","208":"3c4567df","293":"915cf2cc","453":"dc076a17","516":"f98ce771","519":"0d77a5fd","906":"75308483","917":"60d7f175","946":"9be1b032"}[chunkId] + ".chunk.js";
};